/**
 * Call to Action - Become Consul
 * -----------------------------
 *
 * Expected variables:
 * - activityGroupId
 */
import $ from 'jquery'
import View from 'view/view'
import template from 'component/cta/become_consul/template.tmpl'
import Router from 'service/router'
import ModalView from 'component/modal/modal'
import dataProvider from 'service/data_provider'

const BecomeConsulView = View.extend({
    template,

    events: {
        'click .js-modal-trigger': '_onModalTriggerClick',
    },

    _onModalTriggerClick(e) {
        new ModalView(ModalView.getData($(e.currentTarget)))
    },

    render() {
        this.$el.html(
            this.template({
                isLoggedIn: Boolean(dataProvider.get('currentUser')),
                hasActiveConsuls: this.options.hasActiveConsuls,
                link: {
                    learnMore: Router.path('about_get_involved_index', null, {
                        query: { ref: 'gra_sce_tl' },
                    }),
                    button: Router.path(
                        'activity_group_support_request_new',
                        { activityGroupId: this.options.activityGroupId, context: 'consul-application' },
                        { query: { ref: 'gra_sce_bt' } }
                    ),
                },
            })
        )
        return this
    },
})

export default BecomeConsulView
